import React from 'react';

export interface SelectFilterOption {
  value: string;
  label: string;
}

export interface SelectFilterProps {
  value: string;
  onChange: (value: string) => void;
  options: SelectFilterOption[];
  placeholder?: string;
  label?: string;
  id?: string;
  disabled?: boolean;
}

/**
 * SelectFilter - 드롭다운 select 필터 컴포넌트
 * 옵션 목록을 전달받아 필터링할 수 있는 재사용 가능한 컴포넌트
 */
export const SelectFilter: React.FC<SelectFilterProps> = ({
  value,
  onChange,
  options,
  placeholder = '필터 없음',
  label,
  id,
  disabled = false,
}) => {
  return (
    <div className="flex items-center gap-2">
      {label && (
        <label htmlFor={id} className="text-sm whitespace-nowrap text-slate-500">
          {label}
        </label>
      )}
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="min-w-[140px] cursor-pointer rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm text-slate-700 transition-colors hover:border-slate-300 focus:border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-400">
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
